import { Pipe, PipeTransform } from '@angular/core';
import { PaymentStatus } from '@core/interfaces/payments';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'paymentStatus' })
export class PaymentStatusPipe implements PipeTransform {

  constructor(private translateService: TranslateService) { }

  transform(statusName: string | PaymentStatus): string {
    if (statusName) {
      return this.translateService.instant(`MAINTENANCES.PAYMENTS.STATUS_OPTIONS.${statusName.toString().toUpperCase()}`);
    }
    return null;
  }
}
